import charminar from "../assets/locationImages/charminar.avif";
import mumbai from "../assets/locationImages/mumbai.webp";
import delhi from "../assets/locationImages/delhi.avif";
import bangalore from "../assets/locationImages/banglore.webp";
import chennai from "../assets/locationImages/chennai.webp";
import kolkata from "../assets/locationImages/kolkata.webp";
import pune from "../assets/locationImages/pune.webp";
import ahmedabad from "../assets/locationImages/ahmedabad.webp";
import surat from "../assets/locationImages/surat.webp";
import jaipur from "../assets/locationImages/jaipur.webp";
import lucknow from "../assets/locationImages/lucknow.webp";
import coimbatore from "../assets/locationImages/coimbatore.webp";
import vadodara from "../assets/locationImages/vodadara.webp";
import indore from "../assets/locationImages/indore.webp";
import bhopal from "../assets/locationImages/bhopal.webp";
import chandigarh from "../assets/locationImages/chandigarh.webp";
import goa from "../assets/locationImages/goa.webp";
import kochi from "../assets/locationImages/kochi.webp";
import mohali from "../assets/locationImages/mohali.webp";
import guwahati from "../assets/locationImages/guwahati.webp";

// Map cities to their famous landmarks with proper image URLs
export const getCityLandmark = (city) => {
    const key = (city || '').toLowerCase();

    const landmarkMap = {
        'hyderabad': { name: 'Charminar', image: charminar },
        'mumbai': { name: 'Gateway of India', image: mumbai },
        'delhi': { name: 'India Gate', image: delhi },
        'bangalore': { name: 'Vidhana Soudha', image: bangalore },
        'bengaluru': { name: 'Vidhana Soudha', image: bangalore },
        'chennai': { name: 'Marina Beach', image: chennai },
        'kolkata': { name: 'Howrah Bridge', image: kolkata },
        'pune': { name: 'Shaniwar Wada', image: pune },
        'ahmedabad': { name: 'Sabarmati Ashram', image: ahmedabad },
        'jaipur': { name: 'Hawa Mahal', image: jaipur },
        'lucknow': { name: 'Bara Imambara', image: lucknow },
        'surat': { name: 'Dumas Beach', image: surat },
        'coimbatore': { name: 'Marudhamalai Temple', image: coimbatore },
        'vadodara': { name: 'Laxmi Vilas Palace', image: vadodara },
        'indore': { name: 'Rajwada Palace', image: indore },
        'bhopal': { name: 'Taj-ul-Masajid', image: bhopal },
        'chandigarh': { name: 'Rock Garden', image: chandigarh },
        'goa': { name: 'Baga Beach', image: goa },
        'kochi': { name: 'Chinese Fishing Nets', image: kochi },
        'mohali': { name: 'PCA Stadium', image: mohali },
        'guwahati': { name: 'Kamakhya Temple', image: guwahati }
    };

    return landmarkMap[key] || { name: 'City', image: 'https://images.pexels.com/photos/1007426/pexels-photo-1007426.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop' };
};

// List of all available locations
export const locations = [
    "Mumbai", "Delhi", "Bangalore", "Hyderabad", "Chennai", "Kolkata", "Pune", "Ahmedabad",
    "Surat", "Jaipur", "Lucknow", "Coimbatore", "Vadodara", "Indore", "Bhopal", "Chandigarh",
    "Goa", "Kochi", "Mohali", "Guwahati",
];

// Centre points for the cities exposed in the manual city selectors. These are
// intentionally approximate city-level coordinates (not a user's precise
// location) and make nearby filtering work immediately without a geocoding
// network request.
export const cityCoordinates = {
    Mumbai: { latitude: 19.0760, longitude: 72.8777 },
    Delhi: { latitude: 28.6139, longitude: 77.2090 },
    Bangalore: { latitude: 12.9716, longitude: 77.5946 },
    Bengaluru: { latitude: 12.9716, longitude: 77.5946 },
    Hyderabad: { latitude: 17.3850, longitude: 78.4867 },
    Chennai: { latitude: 13.0827, longitude: 80.2707 },
    Kolkata: { latitude: 22.5726, longitude: 88.3639 },
    Pune: { latitude: 18.5204, longitude: 73.8567 },
    Ahmedabad: { latitude: 23.0225, longitude: 72.5714 },
    Surat: { latitude: 21.1702, longitude: 72.8311 },
    Jaipur: { latitude: 26.9124, longitude: 75.7873 },
    Lucknow: { latitude: 26.8467, longitude: 80.9462 },
    Coimbatore: { latitude: 11.0168, longitude: 76.9558 },
    Vadodara: { latitude: 22.3072, longitude: 73.1812 },
    Indore: { latitude: 22.7196, longitude: 75.8577 },
    Bhopal: { latitude: 23.2599, longitude: 77.4126 },
    Chandigarh: { latitude: 30.7333, longitude: 76.7794 },
    Goa: { latitude: 15.2993, longitude: 74.1240 },
    Kochi: { latitude: 9.9312, longitude: 76.2673 },
    Mohali: { latitude: 30.7046, longitude: 76.7179 },
    Guwahati: { latitude: 26.1445, longitude: 91.7362 },
};
